import {Component, OnInit, Injector, OnDestroy, Inject, EventEmitter, Input, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Meta } from '../../../_models/meta';
import {environment} from '../../../../environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MetaFormComponent } from '../meta-form/meta-form.component';

const API_URL = environment.apiUrl;

@Component({
  selector: 'meta-form-dialog',
  standalone: false,
  templateUrl: 'meta-form-dialog.component.html',
  styleUrls: ['meta-form-dialog.component.scss']
})

export class MetaFormDialogComponent implements OnInit {

  _meta: Meta;
  tiposMeta: any[];
  cursosOpt: any[];
  areas: any[];
  profesores: any[];
  ambitos: any[];
  tags: any[];
  contexto: string;
  metaUnidadID: number | string;
  activeTab = 0;
  textoBusquedaCursos: string;
  textoBusquedaAreas: string;

  guardando = false;
  onSave = new EventEmitter();

  @ViewChild(MetaFormComponent)
  private metaFormComponent: MetaFormComponent;

  constructor(public dialogRef: MatDialogRef<MetaFormDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this._meta = this.data.meta; // this.injector.get('meta', {});
    this.tiposMeta = this.data.categorias; // this.injector.get('categorias', []);
    this.cursosOpt = this.data.cursos; // this.injector.get('cursos', []);
    this.areas = this.data.areas; // this.injector.get('areas', []);
    this.profesores = this.data.profesores; // this.injector.get('profesores', []);
    this.ambitos = this.data.ambitos; // this.injector.get('ambitos', []);
    this.tags = this.data.tags; // this.injector.get('tags', []);
    this.contexto = this.data.contexto || 'meta-form'; // this.injector.get('contexto', 'meta_form');
    this.metaUnidadID = this.data.metaUnidadID || 0; // this.injector.get('metaUnidadID', 0);
    this.activeTab = this.data.activeTab || 0; // this.injector.get('tabActiva', 0);
    this.textoBusquedaCursos = this.data.textoBusquedaCursos;
    this.textoBusquedaAreas = this.data.textoBusquedaAreas;
  }

  actualizar(resp: any) {
    this.onSave.emit(resp);
  }

  cancelar() {
    this.metaFormComponent.cancelar();
  }

  guardar() {
    this.metaFormComponent.guardar();
  }

  guardandoActualizar(event: boolean) {
    this.guardando = event;
  }
}
